import React, { useContext } from "react";
import Page from "../../formatting/Page";
import PageCard from "../../formatting/PageCard";
import { ILLUSTRATIONS } from "../../formatting/Illustration";
import { TitleSection } from "../../formatting/CardSection";
import { useDocumentTitle, TITLE_POSTFIX } from "../../shared/DocumentTitle";
import { CreateContractContext } from "./CreateContract";
import CreateContractForm from "./CreateContractForm";

export default function CreateContractPage() {
  const createContractContext = useContext(CreateContractContext);
  if (!createContractContext) {
    throw new Error("No CreateContractContext found!");
  }
  const { create } = createContractContext;
  const title = "Opprett en kjøpekontrakt";
  useDocumentTitle(`${title} ${TITLE_POSTFIX}`);

  return (
    <Page className="CreateContractPage" footer>
      <PageCard back="/">
        <TitleSection
          title={title}
          illustration={ILLUSTRATIONS.ALL_TOGETHER}
          largeIllustration
        >
          <CreateContractForm onSubmit={create} />
        </TitleSection>
      </PageCard>
    </Page>
  );
}
